import { CartButton } from "@/components/cart/CartButton";
import { SearchButton } from "@/components/search/SearchButton";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";
import { LayoutDashboard, Menu, User, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export function Navbar() {
	const [isScrolled, setIsScrolled] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const location = useLocation();
	const { user, isRetailer, isSupplier } = useAuth();

	const mainNav = [
		// { name: "Home", href: "/" },
		// { name: "Browse", href: "/products" },
	];

	if (isRetailer) {
		mainNav.push({ name: "Orders", href: "/dashboard/orders" });
	}

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 10);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	useEffect(() => {
		setIsMobileMenuOpen(false);
	}, [location.pathname]);

	return (
		<header
			className={cn(
				"fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 md:px-12",
				isScrolled
					? "bg-white/80 backdrop-blur-md border-b border-gray-100/50 shadow-sm"
					: "bg-transparent"
			)}>
			<nav className="mx-auto max-w-7xl flex items-center justify-between">
				<div className="flex items-center gap-10">
					<Link
						to="/"
						className="text-2xl font-display font-bold tracking-tight text-accent transition-all hover:opacity-90"
						aria-label="Starch">
						Starch
					</Link>

					<div className="hidden md:flex items-center gap-6">
						{mainNav.map((item) => (
							<Link
								key={item.name}
								to={item.href}
								className={cn(
									"text-sm font-medium transition-all-ease hover:text-gray-900",
									location.pathname === item.href
										? "text-gray-900"
										: "text-gray-500"
								)}>
								{item.name}
							</Link>
						))}
					</div>
				</div>

				<div className="hidden md:flex items-center gap-4">
					<SearchButton />
					<CartButton />
					{user ? (
						<Link to="/dashboard">
							<Button variant="outline" className="gap-2">
								<LayoutDashboard className="h-4 w-4" />
								<span>Dashboard</span>
							</Button>
						</Link>
					) : (
						<>
							<Link to="/auth">
								<Button
									variant="outline"
									className="gap-2 border-gray-200 text-gray-700 hover:bg-gray-50">
									<User className="h-4 w-4" />
									<span>Login</span>
								</Button>
							</Link>
							<Link to="/auth?signup=true">
								<Button variant="accent">Join Starch</Button>
							</Link>
						</>
					)}
				</div>

				<div className="flex md:hidden items-center gap-2">
					<SearchButton />
					<CartButton />
					<Button
						variant="ghost"
						size="icon"
						aria-label={
							isMobileMenuOpen ? "Close menu" : "Open menu"
						}
						onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
						{isMobileMenuOpen ? (
							<X className="h-6 w-6" />
						) : (
							<Menu className="h-6 w-6" />
						)}
					</Button>
				</div>
			</nav>

			{isMobileMenuOpen && (
				<div className="absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg md:hidden animate-fade-in">
					<div className="max-w-7xl mx-auto p-4 space-y-4">
						{mainNav.map((item) => (
							<Link
								key={item.name}
								to={item.href}
								className={cn(
									"block py-2 text-base font-medium transition-all-ease",
									location.pathname === item.href
										? "text-accent"
										: "text-black/70"
								)}>
								{item.name}
							</Link>
						))}
						<div className="pt-4 grid grid-cols-2 gap-2">
							{user ? (
								<Link to="/dashboard" className="col-span-2">
									<Button className="w-full gap-2">
										<LayoutDashboard className="h-4 w-4" />
										Dashboard
									</Button>
								</Link>
							) : (
								<>
									<Link to="/auth">
										<Button
											variant="outline"
											className="w-full border-gray-200">
											Login
										</Button>
									</Link>
									<Link to="/auth?signup=true">
										<Button className="w-full">Join</Button>
									</Link>
								</>
							)}
						</div>
					</div>
				</div>
			)}
		</header>
	);
}
